export const TEST_ID = 'maintenancePanels';
